import React from 'react'
import Navbar from '../../layout/Navbar'
import "./client.css"

const Dashboard = () => {
  return (
        <div >
      <div id='about-page'>
      <Navbar />
      <div id='about-hero'>
        <h5>CLIENTS</h5>
        <h2>OUR TRUSTED <span>PARTNERS</span></h2>
        <p id='about-text'>We don't build clients, we build relations. Vwrap is delivering high-quality strategic marketing campaigns to its clients, focusing on how to impact the target
audience of the product/service. We always go the extra mile!</p>
      </div>
    </div>
    </div>
  )
}

export default Dashboard
